import { FC, useCallback, useEffect } from 'react'
import { cn } from '@bem-react/classname'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { parse } from 'query-string'

import { Memo } from '@/hoc/Memo'
// import useBackendError from '@/hooks/useBackendError'
import yup from '@/utils/yup-extended'
import { CompleteRecoveringModel } from '@/core/services/Auth/models/AuthModel'

import { Title } from '@/components/Title'
import { FormGroup } from '@/components/form/FormGroup'
import { Field } from '@/components/form/Field'
import { Button } from '@/components/Button'
import { Back } from '@/components/Back'
import { useAppDispatch } from '@/core/store/hooks'
import { changeAuth } from '../AccountPage/store/accont.slice'
import { useLocation, useNavigate } from 'react-router-dom'
import useBackendError from '@/hooks/useBackendError'

import './CompeleteRecovering.scss'
import { changeLoading } from '@/core/services/Loading/store/loading.slice'
import { completeRecoveringPasswordThunk } from '@/core/services/Auth/store/auth.slice'
import { setToast } from '@/core/services/Toast/store/toast.slice'
import { ToastType } from '@/core/services/Toast/types/ToastType'

const cnCompleteRecovering = cn('CompleteRecovering')

export const CompleteRecovering: FC = Memo(() => {
  const { t } = useTranslation('translation')
  const dispatch = useAppDispatch()
  const { search } = useLocation()
  const [setBackendError] = useBackendError()
  // const [setBackendError, fieldsError] = useBackendError()
  const navigate = useNavigate()

  useEffect(() => {
    localStorage.removeItem('token')
    dispatch(changeAuth(false))
  }, [])

  const CompleteRecoveringSchema = yup.object().shape({
    newPassword: yup
      .string()
      .trim()
      .required(t('Password is a required field'))
      .min(
        8,
        t('The value must be at least 8 characters', {
          value: 8,
        }),
      )
      .isValidPassword(t('isInvalidPassword')),
  })

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<CompleteRecoveringModel>({
    mode: 'onChange',
    resolver: yupResolver(CompleteRecoveringSchema),
  })

  const completeRecovering = useCallback(
    async ({ newPassword }: CompleteRecoveringModel) => {
      const { userId, token } = parse(search)
      try {
        const res = await dispatch(
          completeRecoveringPasswordThunk({
            newPassword: newPassword as string,
            recoveringToken: token as string,
            userId: userId as string,
          }),
        ).unwrap()
        if (res === 200) {
          dispatch(
            setToast({
              type: ToastType.success,
              message: t('New password has been successfully created'),
              position: 'top-center',
            }),
          )
          navigate('/')
        }
      } catch (errors) {
        setBackendError(errors)
        dispatch(changeLoading(false))
      }
    },
    [search],
  )

  return (
    <>
      <Helmet>
        <title>{t('Complete Recovering')} | Registration</title>
      </Helmet>
      <div className={cnCompleteRecovering()}>
        <Back />
        <div className={cnCompleteRecovering('wrap')}>
          <form
            className={cnCompleteRecovering('form')}
            onSubmit={handleSubmit(completeRecovering)}
          >
            <Title className={cnCompleteRecovering('title')}>
              {t('Password Recovering')}
            </Title>
            <div className={cnCompleteRecovering('text')}>
              {t('Enter New password')}
            </div>
            <FormGroup>
              <Field
                {...register('newPassword')}
                placeholder={t('Enter new password')}
                label={t('New password')}
                required
                errors={errors.newPassword && errors.newPassword.message}
                type='password'
              />
            </FormGroup>
            <Button type='submit' isLoading={isSubmitting}>
              {t('Submit')}
            </Button>
          </form>
          <div className={cnCompleteRecovering('img')}>
            <img src='/img/dtm.jpeg' alt='Dinamica Generale' />
          </div>
        </div>
      </div>
    </>
  )
})
